import { render, staticRenderFns } from "./BaseTextInput.vue?vue&type=template&id=a1b4f240&"
import script from "./BaseTextInput.vue?vue&type=script&lang=js&"
export * from "./BaseTextInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports